/* Knowledge test LMS API (VLI_Server /api/knowledge-quiz). Uses CRA proxy to :9100 in dev. */

async function requestJson(path, { method = "GET", body } = {}) {
  const res = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    ...(body != null ? { body: JSON.stringify(body) } : {}),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data?.error || res.statusText || "request_failed";
    throw new Error(msg);
  }

  return data;
}

export function startKnowledgeQuiz({
  SubLicenseTypeId,
  UserId,
  questionCount,
  LicenseTypeId,
  quizProfileCode,
}) {
  const payload = {};
  if (SubLicenseTypeId) payload.SubLicenseTypeId = SubLicenseTypeId;
  if (LicenseTypeId) payload.LicenseTypeId = LicenseTypeId;
  if (quizProfileCode) payload.quizProfileCode = String(quizProfileCode).trim();
  if (UserId) payload.UserId = UserId;
  if (questionCount != null && questionCount !== "")
    payload.questionCount = Number(questionCount);
  return requestJson("/api/knowledge-quiz/start", { method: "POST", body: payload });
}

export function submitKnowledgeQuiz({ quizAttemptId, answers }) {
  return requestJson("/api/knowledge-quiz/submit", {
    method: "POST",
    body: { quizAttemptId, answers },
  });
}

export function fetchKnowledgeQuizHistory({ page = 1, pageSize = 100 } = {}) {
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  return requestJson(`/api/knowledge-quiz/history?${query}`);
}

export function deleteKnowledgeQuizAttempt(quizAttemptId) {
  return requestJson(
    `/api/knowledge-quiz/history/${encodeURIComponent(quizAttemptId)}`,
    { method: "DELETE" }
  );
}

export function fetchKnowledgeQuizAttemptDetails(quizAttemptId) {
  return requestJson(
    `/api/knowledge-quiz/history/${encodeURIComponent(quizAttemptId)}/details`
  );
}
